export default function ResumeDownloadButton() {
  const handleClick = () => {
    const link = document.createElement('a');
    link.href = '/assets/kayla-resume-2025.pdf';
    link.download = 'Kayla_Gillam_Wright_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button
      onClick={handleClick}
      className="w-52 bg-gradient-to-r from-emerald-600 to-green-700 text-white py-3 rounded-full hover:scale-105 hover:from-emerald-500 hover:to-green-600 transition-all duration-300 shadow-lg shadow-emerald-500/25"
    >
      Download Resume
    </button>
  );
}